import './modules/navigation.js'
import './modules/popup.js'
import './modules/fade-in.js'

// Capture hash and prevent browser scroll before it happens
let scrollTargetHash = null;
if (window.location.hash) {
  scrollTargetHash = window.location.hash;
  // Remove hash immediately to prevent browser auto-scroll
  history.replaceState(null, '', window.location.pathname + window.location.search);
  // Force scroll to top synchronously
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
}

window.addEventListener("DOMContentLoaded", () => {
 window.addEventListener("load", function(e){

gsap.registerPlugin(SplitText, ScrollTrigger, ScrollToPlugin);

// Handle anchor scroll from another page
if (scrollTargetHash) {
  const targetElement = document.querySelector(scrollTargetHash);
  if (targetElement) {
    gsap.to(window, {
      scrollTo: { y: targetElement, offsetY: 50 },
      duration: 1,
      ease: "power2.inOut"
    });
  }
}

// Defer background pattern image loading
document.querySelectorAll('.background-pattern img[data-src]').forEach(img => {
  img.src = img.dataset.src;
});

}, false);
});


